import React, { Component, useReducer, useEffect, useState } from "react";
import axios from 'axios';

import { PJContext } from "./components/pj-context"
import CONSTS from "./components/pj-constants";

import {PJMediaOrderStart} from "./components/pj-01-purchase-start-[media]"
import {PJPersonalDetails} from "./components/pj-05b-personal-details-[media]";
import {PJPaymentFrame} from "./components/pj-08-payment-frame-[media]";
import {PJOrderSummaryBar} from "./components/pj-01-order-summary-bar-[media]";
import {PJBreadCrumbs} from "./components/pj-breadcrumbs-[media]";



//DF: use wp.element
//Actions types



let initialState = {
    selectedAddons: {},
    standaloneSelected: {},
    totalPrice: 0,
    monthlyTotal: 0,
    currentStep: CONSTS.STEP_1_START,
    existingCustomer: false,
    deposit:0,
    installationFee:0
};


function purchaseAction(state, action) {
    let newState;
    newState = {...state};
    /*
        Make selections
     */
    switch (action.type) {
        case CONSTS.SET_STEP:
            newState.currentStep = action.args.step;
            break;
        case CONSTS.DATA_LOADING:
            //This state change does not need recaulcualtion. Bailing early;
            return {...state, dataLoading: action.loading};

        case CONSTS.LOAD_DATA:
                newState.totalPrice = action.data.price;
                newState.monthlyTotal = action.data.price;
                newState.orderTotal = action.data.price;
            break;
        case CONSTS.CLOSE_JOURNEY:
            jQuery('body').trigger('close-media-purchase-journey');
            break;

    }

    return newState;
}


function MediaPurchaseFunnel(props) {

    const [state, dispatch] = useReducer(purchaseAction, initialState);
    const [data, setData] = useState(false);
    const [formsState, setFormState] = useState({});

    useEffect(() => {
        console.log('Component Loaded.');
        dispatch({type:CONSTS.DATA_LOADING, loading:true});

        axios.post('/getMediaFunnelData', {
            id:props.id,
            type:props.type
        })
            .then(function (response) {
                // console.log(response);
                switch (response.data.status) {
                    case 'OK':
                        if (response.data.data !== false) {
                            setData( response.data.data);// General data storage. DF: Might put it into the main state. But will need refactor all coda that uses it.
                            dispatch({type:CONSTS.LOAD_DATA, data:response.data.data}); // Update journey calculated values
                        } else {
                            dispatch({type:CONSTS.CLOSE_JOURNEY}); // Close journey if no data received. DF: dump error
                        }
                        break;
                    case 'ERROR':
                        setData(false);
                        dispatch({type:CONSTS.CLOSE_JOURNEY}); // Close journey if no data received. DF: dump error
                        break;
                }
            })
            .catch(function (error) {
                setData(false);
            })
            .then(() => { //ALWAYS
                dispatch({type:CONSTS.DATA_LOADING, loading:false});
            })
        ;
    }, []);

    useEffect(() => {
        console.log('Data Loaded.', data);
        if (data !== false) {
            jQuery('body').trigger('media-purchase-funnel-loaded');
        }
    }, [data]);

    useEffect(() => {
        window.addEventListener("message", onOrderComplete, false);
        return function () {
            window.removeEventListener("message", onOrderComplete, false);
        }
    });

    function onOrderComplete(event) {
        if (event.origin === Rev.origin && event.data.orderSuccess === true) {
            dispatch({ type: CONSTS.COMPLETE_JOURNEY, data:data});
            window.removeEventListener("message", onOrderComplete, false);
        }
    }

    function isCurrentStep(step) {
        // return 'current-step';
        return ((state.currentStep === step) ? 'current-step' : '');
    }

    return  (
        <PJContext.Provider value={{ state, formsState, setFormState, dispatch, data, isCurrentStep }}>
        <div className="container purchase-funnel media-purchase-funnel">

            {data !== false &&
                <>
                    <div className="row ">
                        <div className="col-sm-10 offset-sm-1 col-xs-12 offset-xs-0">
                            <PJBreadCrumbs/>
                        </div>
                    </div>

                    {/****************************
                     STEP 1
                     ****************************/}
                    <div className={"select-addons journey-step " + isCurrentStep(CONSTS.STEP_1_START)}>
                        <div className="row heading">
                            <PJMediaOrderStart />
                        </div>
                        <PJOrderSummaryBar />
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-10 offset-1">
                                {/****************************
                                 STEP 5 B
                                 ****************************/}
                                <PJPersonalDetails current={isCurrentStep(CONSTS.STEP_5b_PERSONAL_DETAILS)}/>

                                {/****************************
                                 STEP 8
                                 ****************************/}
                                <PJPaymentFrame current={isCurrentStep(CONSTS.STEP_8_PAYMENT_FRAME)}/>

                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
        </PJContext.Provider>
    );
}


export { MediaPurchaseFunnel };


